import React from "react";
import AdminLayoutWrapper from "../components/AdminLayoutWrapper";

const FinancialYearHelp = () => {
  return (
    <AdminLayoutWrapper>
      <div className="min-h-screen bg-gray-200 py-8 px-4">
        <div className="max-w-5xl mx-auto bg-white rounded-xl shadow-xl p-8">
          {/* Title */}
          <h1 className="text-3xl font-bold text-[#003e62] text-center mb-8">
            Financial Year Setup – Enhancements
          </h1>

          {/* Intro */}
          <p className="text-sm leading-6 text-gray-800 mb-6">
            We will be doing some enhancements on the{" "}
            <b>Financial year setup</b> screen for making it more useful for you
            people.
            <br />
            <br />
            Below we have mentioned the <b>Old</b> & <b>New</b> financial year
            setup screen functionalities. Old will refer to the current system
            and the new will have the enhancements listed.
          </p>

          {/* OLD SYSTEM */}
          <h2 className="text-orange-500 font-bold text-lg mb-2">
            Old System:
          </h2>

          <p className="font-semibold text-sm mt-3">Admin Login:</p>
          <ul className="list-decimal ml-8 text-sm space-y-1 mt-1">
            <li>You had the option to change the financial year settings.</li>
            <li>
              You will be selecting the financial year start date & end date
              details.
            </li>
            <li>Single DB was used for all the financial years.</li>
          </ul>

          <p className="font-semibold text-sm mt-4">User / Branch Login:</p>
          <ul className="list-decimal ml-8 text-sm space-y-1 mt-1">
            <li>
              In Branch login you will select the “Financial year” from the
              financial year dropdown.
            </li>
          </ul>

          {/* NEW SYSTEM */}
          <h2 className="text-orange-500 font-bold text-lg mt-8 mb-2">
            New System:
          </h2>

          <p className="font-semibold text-sm mt-3">Admin Login:</p>
          <ul className="list-decimal ml-8 text-sm space-y-3 mt-1">
            <li>
              In the Financial year setup screen, we will be creating the new
              financial year details like, Next financial year, Start date and
              End Date. The Start date would be set to <b>1st April</b> and the
              end date will be <b>31st March</b>.
            </li>
            <li>Dates will be preset and you will not able to edit them.</li>
            <li>
              Whenever you select the financial year and click on the Create
              button in the financial year setup screen, a new DB will be created
              for that new financial year.
            </li>
            <li>
              You can create the new DB any time by just clicking on the “Create
              button” for the selected new financial year.
            </li>
            <li>
              When you click on the Create button the following processes will be
              done automatically:
              <ul className="list-disc ml-8 mt-2">
                <li>
                  Closing stock of the last financial year will be set as the
                  Opening stock of the current financial year.
                </li>
              </ul>
            </li>
            <li>
              When you create the new financial year, automatically the previous
              financial year will be deactivated.
            </li>
          </ul>

          {/* USER LOGIN */}
          <p className="font-semibold text-sm mt-6">User Login:</p>
          <ul className="list-decimal ml-8 text-sm space-y-3 mt-1">
            <li>
              By default the current financial year will be set in the login
              screen.
            </li>
            <li>
              You will be able to view the last financial year’s details but
              cannot edit / create any transactions in it.
            </li>
            <li>
              For the above purpose we will add an additional screen in all the
              branches called <b>“Branch item stock update”</b> and here you can
              update the stock details with the reason why the item stock is
              updated in the Narration box. While clicking on the submit button
              after editing the records, we should provide alert message for them
              to confirm.
            </li>
            <li>
              You can change the closing stock of any item, until the item gets
              referred in any transactions. Once it gets referred, stock cannot
              be edited.
            </li>
            <li>
              After new financial year setup, the price of the items would be the
              last transaction’s price.
              <ul className="list-disc ml-8 mt-2">
                <li>
                  Closing stock increase – will be maintained as Store Receipts
                </li>
                <li>
                  Closing stock decrease – will be maintained as Store Issues
                </li>
              </ul>
            </li>
          </ul>

          {/* NOTE */}
          <div className="mt-6 text-sm text-gray-700">
            <p className="font-semibold">Note:</p>
            <ul className="list-disc ml-8 mt-2 space-y-1">
              <li>
                If the closing stock is getting increased, user should enter the
                price.
              </li>
              <li>
                If it’s getting decreased – price will be disabled (old price
                will be considered).
              </li>
              <li>
                We will be creating separate DBs for every financial year and
                run the updated script in the new ones.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </AdminLayoutWrapper>
  );
};

export default FinancialYearHelp;
